module.exports = __webpack_public_path__ + "assets/img/shijianjiqi.0c627103.png";